// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
function fallbackCopyTextToClipboard(copyText: string) {
  const textArea = document.createElement('textarea');
  textArea.value = copyText;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {

    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}

export default function copyToClipboard(copyText: string) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(copyText);
    return;
  }
  navigator.clipboard.writeText(copyText);
}
